if (!customElements.get("wish-list-page")) {
  // noinspection JSUnusedGlobalSymbols
  class WishListPage extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * Invoked each time one of the custom element's attributes is added, removed, or changed
     */
    attributeChangedCallback() {
      this.rendered = false;
      this.html = undefined;
      this.init();
    }

    /**
     * Runs when element is created
     */
    connectedCallback() {
      if (!this.rendered) {
        this.init();
      }
    }

    /**
     * Initialize state data
     */
    setupData() {
      this.data = {
        wishListBtnSelector: "wish-list-button",
        message: {
          emptyItem:
            this.getAttribute("messageEmptyItem") ||
            "お気に入りリストに登録している商品はありません",
          error:
            this.getAttribute("messageError") || "Data cannot be obtained.",
        },
      };
    }

    /**
     * When the user click the wishlist button
     */
    addEventForWishListButton() {
      let wishListButtonSelector = this.data.wishListBtnSelector;
      let wishListButtons = this.querySelectorAll(wishListButtonSelector);
      if (wishListButtons.length) {
        wishListButtons.forEach((button) => {
          // Called when wishlist status change event in `assets/wish-list-button.js`
          button.addEventListener("changeStatus", () => {
            let wishListButtonElements = this.querySelectorAll(
              wishListButtonSelector
            );
            if (wishListButtonElements.length > 1) {
              button.closest(".collection__item").remove();
            } else {
              this.renderEmpty();
            }
          });
        });
      }
    }

    /**
     * Initialize data
     */
    init() {
      this.startLoading();
      this.setupData();
      this.loaded((swat) => {
        this.swat = swat;
        this.render();
      });
      this.rendered = true;
    }

    /**
     * Initialize connect to App
     * @param callback
     */
    loaded(callback) {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push((swat) => {
        callback(swat);
      });
    }

    /**
     * @param callback
     */
    afterRender(callback) {
      setTimeout(() => {
        callback();
      }, 600);
      const content = this.querySelector('[data-js="content"]');
      content.parentElement.classList.remove("default");
    }

    /**
     * Based on file `search.wishlist.liquid` to get HTML json
     *
     * @param list
     * @returns {Promise<any>}
     */
    async renderProductHTML(list) {
      try {
        let variantIds = list.map((item) => {
          return item.epi;
        });
        let productIds = list.map((item) => {
          return `(id:"${item.empi}")`;
        });
        let queryString = Array.from(new Set(productIds)).join(" OR ");
        if (list.length > 0) {
          return await fetch(
            `${window.origin}/search?view=wishlist&variant_ids=` +
              variantIds.join("-") +
              "&type=product&q=" +
              queryString,
            {
              method: "GET",
              body: JSON.stringify(),
            }
          )
            .then((response) => response.text())
            .then((data) => data);
        } else {
          this.renderEmpty();
        }
      } catch (e) {
        this.renderError();
      }
    }

    /**
     * Render HTML
     */
    render() {
      this.swat.fetch((list) => {
        // Invoked at most once after being added
        if (typeof this.html === "undefined" && list.length) {
          this.renderProductHTML(list).then((data) => {
            if (!data) return;
            this.html = data;
            let stockData = document.createElement("div");
            stockData.innerHTML = this.html;

            const content = this.querySelector(
              '.collection__items[data-js="content"]'
            );

            //バリエーションごとの商品画像を設定
            for (let i = 0; i < list.length; i++) {
              // Documentオブジェクトから特定の要素を選択
              let element = stockData.querySelector(
                `wish-list-button[product-variant-id="${list[i].epi}"]`
              );

              if (element) {
                let image = element
                  .closest("li")
                  .querySelector(".collection__item-media");
                image.setAttribute("data-bg", list[i].iu);

                let links = element.closest("li").querySelectorAll("a");
                links.forEach((link) => {
                  link.href += "&variant=" + list[i].epi;
                });
              }
            }

            content.style.display = "none";
            content.innerHTML = stockData.innerHTML;
            this.afterRender(() => {
              this.addEventForWishListButton();
              content.style.display = "flex";
              this.endLoading();
            });
          });
        } else {
          this.renderEmpty();
          this.endLoading();
        }
      });
    }

    /**
     * Show Empty Message
     */
    renderEmpty() {
      const content = this.querySelector('[data-js="content"]');
      content.parentElement.classList.add("default");
      content.parentElement.innerHTML = `<p>${this.data.message.emptyItem}</p>`;
    }

    /**
     * Show Error Message
     */
    renderError() {
      const content = this.querySelector('[data-js="content"]');
      content.parentElement.classList.add("default");
      content.parentElement.innerHTML = `<span>${this.data.message.error}</span>`;
    }

    startLoading() {
      this.classList.add("loading");
    }

    endLoading() {
      this.classList.remove("loading");
    }
  }

  customElements.define("wish-list-page", WishListPage);
}
